export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(" ");
}

export function formatPtPhoneDigits(value: string): string {
  return value.replace(/\s+/g, "").replace(/^(?:\+351|00351)/, "");
}

export function isPtPhone(value: string): boolean {
  return /^[2369]\d{8}$/.test(formatPtPhoneDigits(value));
}

export function formatDatePt(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat("pt-PT", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(date);
}

export function formatDateOnly(iso: string | null): string {
  if (!iso) return "—";
  const date = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat("pt-PT", { dateStyle: "medium" }).format(date);
}

export function statusLabel(status: string): string {
  const map: Record<string, string> = {
    pendente: "Pendente",
    agendado: "Agendado",
    em_curso: "Em curso",
    concluido: "Concluído",
    cancelado: "Cancelado",
  };
  return map[status] ?? status;
}

export function periodLabel(period: string | null): string {
  const map: Record<string, string> = {
    manha: "Manhã",
    tarde: "Tarde",
    noite: "Noite",
  };
  return period ? (map[period] ?? period) : "—";
}

export function contactPrefLabel(value: string): string {
  const map: Record<string, string> = {
    telefone: "Telefone",
    email: "Email",
    whatsapp: "WhatsApp",
  };
  return map[value] ?? value;
}
